import { log10 } from 'chart.js/helpers';
import React, { useState } from 'react';
import Chart from 'react-apexcharts';

const AreaChart = ({graphdata}) => {
  const currentYear = new Date().getFullYear();
  const lastFiveYears = Array.from({ length: 5 }, (_, i) => currentYear - i).reverse(); 

  const [filter, setFilter] = useState(currentYear); 
 console.log("graphdata",graphdata);
 
  

  const LineChartData = {
    vehicles: {
      2024: [150, 200, 180, 220, 300, 250, 400, 350, 300, 320, 420, 450],
      2023: [140, 190, 170, 210, 290, 240, 390, 340, 290, 310, 410, 440],
      2022: [130, 180, 160, 200, 280, 230, 370, 320, 280, 300, 390, 420],
      2021: [120, 170, 150, 190, 270, 220, 350, 310, 270, 290, 370, 400],
      2020: [110, 160, 140, 180, 260, 210, 330, 290, 260, 280, 350, 380],
    },
    spareParts: {
      2024: [100, 150, 130, 180, 240, 190, 340, 300, 250, 270, 370, 400],
      2023: [90, 140, 120, 170, 230, 180, 320, 280, 240, 260, 350, 380],
      2022: [80, 130, 110, 160, 220, 170, 300, 270, 230, 250, 330, 360],
      2021: [70, 120, 100, 150, 210, 160, 280, 250, 220, 240, 310, 340],
      2020: [60, 110, 90, 140, 200, 150, 260, 230, 210, 220, 290, 320],
    },
    accessories: {
      2024: [80, 120, 110, 150, 190, 160, 250, 220, 210, 240, 290, 310],
      2023: [70, 110, 100, 140, 180, 150, 230, 200, 190, 220, 270, 300],
      2022: [60, 100, 90, 130, 170, 140, 210, 180, 170, 200, 250, 280],
      2021: [50, 90, 80, 120, 160, 130, 190, 160, 150, 180, 230, 260],
      2020: [40, 80, 70, 110, 150, 120, 170, 140, 130, 160, 210, 240],
    },
  };

  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const chartData = {
    series: [
      {
        name: 'Vehicles',
        data: graphdata?.vehicles[filter], 
      },
      {
        name: 'Spare Parts',
        data: graphdata?.spareParts[filter], 
      },
      {
        name: 'Accessories',
        data: graphdata?.accessories[filter],
      },
    ],
    options: {
      chart: {
        type: 'area',
        height: 350,
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
      },
      xaxis: {
        categories: months, 
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.2,
          stops: [0, 90, 100],
        },
      },
      tooltip: {
        x: {
          format: 'MMM',
        },
      },
      legend: {
        position: 'top',
      },
    },
  };

  return (
    <div className="area-chart-container">
       <h6>Sales Over the Months</h6>
      {/* <div className="filter-container">
        <h6>Sales Over the Months</h6>
        <div className="filter">
          <label>
            <select value={filter} onChange={(e) => setFilter(e.target.value)} className='me-2 mb-2'>
              {lastFiveYears.map((year, index) => (
                <option key={index} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </label>
        </div>
      </div> */}

      <div style={{ height: '350px' }}>
        <Chart options={chartData?.options} series={chartData?.series} type="area" height={350} />
      </div>
    </div>
  );
};

export default AreaChart;
